import { site } from "@/config/site";
import { JsonLd } from "./JsonLd";

export const LocalBusinessJsonLd = () => {
  const data = {
    "@context": "https://schema.org",
    "@type": "HealthAndBeautyBusiness",
    "@id": `${site.siteUrl}/#business`,
    name: site.name,
    url: `${site.siteUrl}/`,
    image: `${site.siteUrl}${site.heroImage}`,
    logo: `${site.siteUrl}/images/lavenza-spa-logo.png`,
    telephone: site.phoneE164,
    address: {
      "@type": "PostalAddress",
      streetAddress: site.address.street,
      addressLocality: site.address.locality,
      addressRegion: site.address.region,
      addressCountry: site.address.country,
    },
    openingHoursSpecification: {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: site.openingHours.days,
      opens: site.openingHours.opens,
      closes: site.openingHours.closes,
    },
    sameAs: [site.instagram],
    hasMap: site.mapsDirectionsUrl,
    areaServed: site.areaServed.map((name) => ({ "@type": "Place", name })),
  };
  return <JsonLd id="local-business" data={data} />;
};
